import { EventsContainer } from "./EuphaEvents.style";
import { TitleEuphaWorld } from "../../styles/Layout.style";

const EuphaEvents = () => {
  return (
    <EventsContainer>
      <TitleEuphaWorld>
        <p>
          <span>Eventos</span> EuphaPharma
        </p>
        <p>...</p>
        <p>
          Trascendiendo en cada iniciativa que emprendemos, nos esforzamos
          constantemente por posicionarnos como líderes en nuestros sectores.
          Buscamos contribuir de manera significativa a la salud.
        </p>
      </TitleEuphaWorld>
    </EventsContainer>
  );
};

export default EuphaEvents;
